module.exports = {
    baseURL: '//note-server.hunger-valley.com/' }
